import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadUsers = createAsyncThunk(
    'users/loadUsers',
    async ({bankId, token}) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/admin/users/${bankId}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadAllUsers = createAsyncThunk(
    'users/loadAllUsers',
    async (token) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/admin/users`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const manageUsersSlice = createSlice({
    name: 'users',
    initialState: {
        users: [],
        usersLoading: false,
        failedToLoadUsers: false
    },
    reducers: {
        addUser: (state, action) => {
            return {
                ...state,
                users: [...state.users, action.payload]
            }
        },
        updateUserInfo: (state, action) => {
            const newUserList = state.users.map(user => {
                if (user.username === action.payload.username) {
                    return {
                        ...user,
                        name: action.payload.name,
                        userRole: action.payload.userRole,
                        branchId: action.payload.branchId
                    }
                } else {
                    return user;
                }
            })
            return {
                ...state,
                users: newUserList
            }
        },
        removeUser: (state, action) => {
            const newUserList = state.users.filter(user => user.username !== action.payload);
            return {
                ...state,
                users: newUserList
            }
        },
        clearUsers: (state) => {
            return {
                ...state,
                users: []
            }
        }
    },
    extraReducers: {
        [loadUsers.pending]: (state) => {
            return {
                ...state,
                usersLoading: true,
                failedToLoadUsers: false
            }
        },
        [loadUsers.fulfilled]: (state, action) => {
            return {
                ...state,
                users: action.payload,
                usersLoading: false,
                failedToLoadUsers: false
            }
        },
        [loadUsers.rejected]: (state) => {
            return {
                ...state,
                usersLoading: false,
                failedToLoadUsers: true
            }
        },
        [loadAllUsers.pending]: (state) => {
            return {
                ...state,
                usersLoading: true,
                failedToLoadUsers: false
            }
        },
        [loadAllUsers.fulfilled]: (state, action) => {
            return {
                ...state,
                users: action.payload,
                usersLoading: false,
                failedToLoadUsers: false
            }
        },
        [loadAllUsers.rejected]: (state) => {
            return {
                ...state,
                usersLoading: false,
                failedToLoadUsers: true
            }
        }
    }
})

export const selectUsers = (state) => state.users.users;
export const loadingUsers = (state) => state.users.usersLoading;

export const { addUser, updateUserInfo, removeUser, clearUsers } = manageUsersSlice.actions;

export default manageUsersSlice.reducer;